import React,{useRef, useEffect, useState} from 'react'
import { Outlet } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

import LandingHeader from './components/header/LandingHeader';
import LandingFooter from './components/footer/LandingFooter';



const LandingLayout = () => {
  const SITE_KEY = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    script.onload = () => {
      try{
        if (window.grecaptcha) {
          window.grecaptcha.ready(() => {
            window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then((token) => {});
          });
        }
      }
      catch(e){
        console.error(e)
      }
    };
  }, [SITE_KEY]);

  return (
    <>
      <ToastContainer/>
      <LandingHeader/>
      <div className="has-smooth" id="has_smooth"></div>
      <div className='tv-body' id="smooth-wrapper">
        <div id="smooth-content">
          <div className="body-wrapper body-booking">
            <div className="overlay-switcher-close"></div>
              <Outlet/>
              <LandingFooter/>
          </div>
        </div>
      </div>
    </>
  )
}
export default LandingLayout